import React, { useState, useEffect } from "react";
import ScrollToTop from "../components/scroll-to-top";
import SEO from "../components/seo";
import ProjectContainer from "../containers/project";
import PageTitle from "../components/page-title";
import Layout from "../layouts";
import Footer from "../layouts/footer";
import Header from "../layouts/header";
import ProjectItem from "../components/project/project-item";
import ProjectForm from "../components/project-form";
import axios from "axios";
import cogoToast from "cogo-toast";

import { useParams } from "react-router-dom";

const AddProject = () => {
    const [data, setData] = useState({
        id: 1,
        media: {
            thumb: "./images/project/project-1.jpg",
            image: "./images/project-details/project-details.jpg",
        },
        title: "Enter your title...",
        description: "",
        img: "",
    });

    const { id } = useParams();

    useEffect(
        () => {
            if (id) {
                axios
                    .get(
                        "https://soul-house-harmony.onrender.com/project/" + id
                    )
                    .then((res) => {
                        console.log(res.data);

                        setData({
                            id: res.data.project._id,
                            media: {
                                thumb: res.data.project.cover,
                                image: "./images/project-details/project-details.jpg",
                            },
                            title: res.data.project.name,
                            description: res.data.project.description,
                            img: res.data.project.cover,
                        });

                        // const temp = [];
                        // res.data.allProjects.map((x) => {
                        //     temp.push({
                        //         id: x._id,
                        //         media: { thumb: x.cover },
                        //         title: x.name,
                        //     });
                        // });
                        // setData(temp);
                    })
                    .catch((err) => {
                        console.log(err);
                        cogoToast.info("Error submitting form", {
                            position: "bottom-left",
                        });
                    });
            }
        },
        { id }
    );

    const handleSubmit = () => {
        console.log(data);
        console.log(id);
        let bodyFormData = new FormData();
        bodyFormData.append("file", data.img);
        bodyFormData.append("name", data.title);
        bodyFormData.append("description", data.description);
        if (id) {
            axios
                .patch(
                    "http://192.168.1.20:8000/project/edit/" + id,
                    bodyFormData,
                    {
                        headers: {
                            Authorization: JSON.parse(
                                sessionStorage.getItem("admin")
                            ).token,
                        },
                    }
                )
                .then((res) => {
                    console.log(res);
                    if (res.status === 200)
                        cogoToast.success("Edited successfully", {
                            position: "bottom-left",
                        });
                })
                .catch((err) => {
                    console.log(err);
                    cogoToast.info("Error submitting form", {
                        position: "bottom-left",
                    });
                });
        } else {
            axios
                .post(
                    "https://soul-house-harmony.onrender.com/project/add",
                    bodyFormData,
                    {
                        headers: {
                            Authorization: JSON.parse(
                                sessionStorage.getItem("admin")
                            ).token,
                        },
                    }
                )
                .then((res) => {
                    console.log(res);
                    if (res.status === 200)
                        cogoToast.success("submitted successfully", {
                            position: "bottom-left",
                        });
                })
                .catch((err) => {
                    console.log(err);
                    cogoToast.info("Error submitting form", {
                        position: "bottom-left",
                    });
                });
        }
    };

    return (
        <React.Fragment>
            <Layout>
                <SEO title="Andle - Project" />

                <div className="main-wrapper">
                    <Header />
                    <div className="container">
                        <PageTitle title="Add Projects" />
                        <div
                            className="messonry-button"
                            data-aos="fade-up"
                            data-aos-duration="1200"
                        ></div>
                    </div>
                    <div className="section section-padding-03">
                        <div
                            className="row grid project-list"
                            style={{ justifyContent: "space-around" }}
                        >
                            <div
                                key={1}
                                className={`col-xl-6 col-md-6 masonry-grid mt-10 p-9`}
                            >
                                <ProjectForm
                                    setData={setData}
                                    data={data}
                                    handleSubmitProp={handleSubmit}
                                />
                            </div>
                            <div
                                key={1}
                                className={`col-xl-4 col-md-6 masonry-grid p-9`}
                            >
                                <ProjectItem data={data} add={true} />
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
                <ScrollToTop />
            </Layout>
        </React.Fragment>
    );
};

export default AddProject;
